import { COMMON_CONSTANTS } from "~/constants/common-constants";

export interface ErrorInfo {
  errorCode: number;
  error: string;
  type: string;
}

export interface DialogInfo {
  statusCode: number;
  dialogText: string;
}

export interface ErrorsComposition {
  handleErrorResponse(response: any): ErrorInfo;
}

export const useErrors = (): ErrorsComposition => {
  const handleErrorResponse = (response: any): ErrorInfo => {
    let errorMsg = COMMON_CONSTANTS.DEFAULT_ERROR_MESSAGE;
    if (!response) {
      return {
        errorCode: 0,
        error: errorMsg,
        type: "",
      };
    }
    switch (response.status) {
      case 404:
        errorMsg = COMMON_CONSTANTS.DEFAULT_ERROR_MESSAGE_404;
        break;
      case 401:
      case 403:
      case 422:
      case 427:
      case 429:
        errorMsg = response.data.message || errorMsg;
        break;
      default:
        break;
    }

    return {
      errorCode: response.status,
      error: errorMsg,
      type: response.type || "",
    };
  };

  return {
    handleErrorResponse,
  };
};
